export default __webpack_public_path__ + "static/media/logoFincrea.46fb05ed.png";